export default __webpack_public_path__ + "file/Fiche-EN-Produit-Puroak-Granulés.asset.8ca35113.pdf";